
export class DataUtilsService {

    static getObjectByAnything(param) {
        let dataset = [];
        if(typeof param === 'string' || param instanceof String){
            const lines = param.split("\n");
            lines.forEach( line => {
                if(line)
                    dataset.push(JSON.parse(line))
            })

        } else if(typeof param === 'object' || param instanceof Object) {
            dataset.push(param)
        } else {
            throw "Não foi possivel determinar o tipo de retorno de dados: " + param;
        }
        return dataset;
    }
}
